class CollapsibleRow extends HTMLElement {
  constructor() {
    super();
    
    this.rows = this.querySelectorAll('.collapsible-row__row');

    this.init();

    window.addEventListener('resize', this.resize.bind(this));
  }

  init() {
    this.rows.forEach(row => {
      this.setRowHeight(row);
      row.querySelector('.collapsible-row__header').addEventListener('click', (event) => {
        this.handleClick(row);
      })      
    })
  }

  resize() {
    this.rows.forEach(row => {
      this.setRowHeight(row);
    })
  }

  headerHeight(row) {
    return row.querySelector('.collapsible-row__header').offsetHeight;
  }

  contentHeight(row) {
    return row.querySelector('.collapsible-row__content').offsetHeight;
  }

  setRowHeight(row) {
    row.style.height = `${this.headerHeight(row)}px`;
  }

  handleClick(row) {
    if (row.hasAttribute('open')) {
      this.closeAll();
    } else {
      this.open(row)
    }
  }

  open(row) {
    this.closeAll();
    row.style.height = `${this.headerHeight(row) + this.contentHeight(row)}px`;
    row.setAttribute('open', '');
  }

  closeAll() {
    this.rows.forEach(row => {
      this.setRowHeight(row);
      row.removeAttribute('open');
    })
  }
}

customElements.define('collapsible-row', CollapsibleRow);